import { resolveSportModule } from "./registry";

/**
 * Resolve scoringSystem from the sport module (no sport-specific ifs).
 * @param {string | null | undefined} sportId
 * @returns {string}
 */
export function resolveScoringSystem(sportId) {
  const mod = resolveSportModule(sportId);
  const fromConfig = mod?.createMatchConfiguration?.()?.getScoringSystem?.();
  if (fromConfig) return String(fromConfig);
  const fromEngine = mod?.createMatchEngine?.()?.scoringSystem;
  if (fromEngine) return String(fromEngine);
  return "rally";
}
